<div class="background">
    <div class="dialog-header">
        <h2>Export Translations</h2>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div style="display: flex; justify-content: center">
        <h3> {{ product ? product.name : version?.name }}</h3>
    </div>

    <div>
        <label class="custom-label">Language</label>
        <mat-form-field style="width: 100%; margin-top: 10px">
            <mat-select [formControl]="selectedLanguage">
                @for (language of (languages$ | async); track language.id) {
                    @if (language.id !== 1) {
                        <mat-option [value]="language">{{ language.name }}
                        </mat-option>
                    }
                }
            </mat-select>
        </mat-form-field>

        <mat-divider style="margin-right: -20px; margin-left: -20px"></mat-divider>

        <form [formGroup]="check" class="jira-form">
            <h3>Jira Issue Key for importing to Jira</h3>
            <mat-form-field class="full-width">
                <mat-label>Please enter the Jira Issue Key for your Translation</mat-label>
                <input (input)="inputChanged()" (keydown.enter)="enterCheck()"
                       formControlName="issueKey" matInput placeholder="12345">
                <button *ngIf="(checkedNote$ | async) === null" [class.spinner]="loading" mat-icon-button matSuffix
                        matTooltip="Not Checked" matTooltipPosition="above">
                    <mat-icon>help_outline</mat-icon>
                </button>
                <button *ngIf="(checkedNote$ | async) === CheckStatus.Available" color="primary" mat-icon-button
                        matSuffix
                        matTooltip="Valid Jira Issue Key" matTooltipPosition="above">
                    <mat-icon>done</mat-icon>
                </button>
                <button *ngIf="(checkedNote$ | async) === CheckStatus.Invalid" color="warn" mat-icon-button matSuffix
                        matTooltip="Invalid Jira Issue Key" matTooltipPosition="above">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <button (click)="checkNote()" [disabled]="!check.valid" color="primary" class="check-button"
                    mat-raised-button>
                Check
            </button>
        </form>
    </div>

    <mat-card
            [ngClass]="{'status-edited': (exportedTranslation$ | async) === true, 'status-failed': (exportedTranslation$ | async) === false, 'status-not-edited': !exportPressed}"
            class="exported-card">
        <p *ngIf="!exportPressed">Export your translation file to Jira or your file system.</p>
        @if (exportPressed) {
            <p *ngIf="(exportedTranslation$ | async) === null">Exporting...</p>
            <p *ngIf="(exportedTranslation$ | async) === true">Exported translation file.</p>
            <p *ngIf="(exportedTranslation$ | async) === false">Could not export translation file.</p>
        }
    </mat-card>

    @if ((exportedTranslation$ | async) && exportPressed) {
        <a style="margin: 10px auto auto;" target="_blank"
           href="https://jira-auma.atlassian.net/browse/{{checkedIssueKey}}">{{ "https://jira-auma.atlassian.net/browse/" + checkedIssueKey }}</a>
    }

    <div style="display: flex; justify-content: space-between">
        <button (click)="exportFile()" class="div-button" color="primary" mat-raised-button
                [disabled]="!((permissionService.accessRights$|async)?.userRight_RIS2_EXPORT_TRANSLATION_VERSION$|async)">
            <mat-icon>file_copy</mat-icon>
            Export Translations File
        </button>

        <button (click)="exportJira()" class="div-button" color="primary" mat-raised-button
                [disabled]="!((permissionService.accessRights$|async)?.userRight_RIS2_EXPORT_TRANSLATION_VERSION$|async) || !((checkedNote$ | async) === CheckStatus.Available)">
            <mat-icon>file_copy</mat-icon>
            Export Translations File to Jira
        </button>
    </div>
</div>

